angular.module('hjApp').controller('ModalUpdatePurchaseOrder', [
    'invoice',
    function (invoice) {
        this.model = {
            invoice: invoice,
            po_number: invoice.po_number
        };
    }
]);
